"use client"

import {
  ArtifactCanvasBody,
  ArtifactCanvasDismissAction,
  ArtifactCanvasFooterBar,
} from '@yeshuman/sdk'
import { CVUploadFields } from './cv-upload'

export type CvUploadCanvasFormProps = {
  onClose: () => void
}

export function CvUploadCanvasForm({ onClose }: CvUploadCanvasFormProps) {
  return (
    <>
      <ArtifactCanvasBody className="min-h-0 flex-1 space-y-4 overflow-y-auto">
        <p className="text-sm text-muted-foreground">
          Upload files (PDF or DOCX). Each file is parsed into a searchable profile with skills,
          experience, and structured metadata.
        </p>
        <CVUploadFields />
      </ArtifactCanvasBody>
      <ArtifactCanvasFooterBar
        footerClassName="shrink-0"
        actions={<ArtifactCanvasDismissAction onClose={onClose} label="Done" />}
      />
    </>
  )
}
